import {Tree, Dropdown, DropdownItem, DropdownMenu, Autocomplete, Alert, Tag} from 'element-ui';

const customElement = {
    install: function (Vue) {
        Vue.component('el-tree', Tree);
        Vue.component('el-alert', Alert);
        Vue.component('el-dropdown', Dropdown);
        Vue.component('el-tag', Tag);
        Vue.component('el-dropdown-menu', DropdownMenu);
        Vue.component('el-dropdown-item', DropdownItem);
        Vue.component('el-autocomplete', Autocomplete);

    }
};
export default customElement;
